<!--
 * @Author: your name
 * @Date: 2020-08-25 08:47:10
 * @LastEditTime: 2020-09-04 10:19:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\components\about\cooperative.vue
-->
<template>
<div class="cooperative">
    <h1>佳驰荣誉</h1>
    <p>Jiachi Honors</p>
    <swiper :options="options" v-if="list.length">
        <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="td">
                <img :src="item.image" alt srcset />
            </div>
        </swiper-slide>
        <div class="dot" slot="pagination"></div>
    </swiper>
</div>
</template>

<script>
import {
    hzhb
} from '../../assets/js/api'
export default {
    data() {
        return {
            list: [],
            options: {
                slidesPerView: 5,
                spaceBetween: 114,
                slidesPerGroup: 5,

                autoplay: {
                    delay: 3000
                },
                pagination: {
                    el: ".dot",

                },
            },
        };
    },
    created() {
        hzhb({
            limit: 9999
        }).then(r => {
            this.list = r.data.data
        })
    }
};
</script>

<style lang="less" scoped>
.cooperative {
    text-align: center;
    padding-top: 90px;

    &>h1 {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
    }

    &>p {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
        margin-bottom: 60px;
    }
}

table {
    border-collapse: collapse;
    width: 1200px;
    border-color: rgba(232, 232, 232, 1);
    display: block;
    margin: 0 auto;
}

.td {
    border-color: rgba(232, 232, 232, 1);
    height: 100px;
    display: inline-block;
    position: relative;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    width: 100%;

    img {
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

.swiper-container {
    width: 1200px;
    margin-bottom: 90px;

    .swiper-slide {
        width: 100%;
    }

    /deep/.swiper-wrapper {
        margin-bottom: 20px;
    }

    /deep/.swiper-pagination-bullet {
        border-radius: 0;
    }
}
</style>
